'use client'

import { BlocksProps } from '@/lib/wordpress/_types/blocksStyle'
import { getImageInfoFromInnerblock } from '@/lib/wordpress/blocks/getImageInfoFromInnerblock'
import { EmptyState, ITestimonialsCard, TestimonialsCard } from 'igualigual-ds'
import Image from 'next/image'

export interface IBlockTestimonialsCard {
  attrs: IAttrs | Record<string, any>
  innerBlocks: BlocksProps[]
}
export interface IAttrs extends Omit<ITestimonialsCard, 'imageElement'> {
  imageUrl: string
}

export default function BlockTestimonialsCard({
  attrs,
  innerBlocks
}: IBlockTestimonialsCard) {
  const { imageUrl, description, author } = attrs || {}

  const newImage = getImageInfoFromInnerblock(innerBlocks)

  const image = newImage?.url ? (
    <Image
      decoding="async"
      src={newImage?.url}
      fill
      alt={`Fotografia de ${author}`}
      style={{ objectFit: 'cover' }}
    />
  ) : (
    <EmptyState />
  )

  return (
    <TestimonialsCard
      imageElement={image}
      description={description}
      author={author}
    />
  )
}
